import * as tslib_1 from "tslib";
import { PolyUiForm, SvgForm } from '@swim/ui';
var PlotForm = (function (_super) {
    tslib_1.__extends(PlotForm, _super);
    function PlotForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlotForm.addGlobal = function (plotForm) {
        PlotForm.Global = PlotForm.Global.withUiForm(plotForm);
    };
    PlotForm.removeGlobal = function (plotForm) {
        PlotForm.Global = PlotForm.Global.withoutUiForm(plotForm);
    };
    PlotForm.Global = new PolyUiForm([]);
    return PlotForm;
}(SvgForm));
export { PlotForm };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxvdC1mb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGxvdC1mb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsVUFBVSxFQUFFLE9BQU8sRUFBQyxNQUFNLFVBQVUsQ0FBQztBQUk3QztJQUEwRixvQ0FBYTtJQUF2Rzs7SUFVQSxDQUFDO0lBUFEsa0JBQVMsR0FBaEIsVUFBaUIsUUFBNEI7UUFDM0MsUUFBUSxDQUFDLE1BQU0sR0FBRyxRQUFRLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUN6RCxDQUFDO0lBRU0scUJBQVksR0FBbkIsVUFBb0IsUUFBNEI7UUFDOUMsUUFBUSxDQUFDLE1BQU0sR0FBRyxRQUFRLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBUk0sZUFBTSxHQUFHLElBQUksVUFBVSxDQUFnQyxFQUFFLENBQUMsQ0FBQztJQVNwRSxlQUFDO0NBQUEsQUFWRCxDQUEwRixPQUFPLEdBVWhHO1NBVnFCLFFBQVEifQ==